// Helper Functions
// Note: Permission-related functions have been moved to utils/permissions.js

import moment from 'moment';

// Re-export from permissions.js for backward compatibility
export {
  isLogin,
  getUserToken,
  getUserData,
  getUserType,
  getUserId,
  getUserName,
  getRefreshToken,
  clearStorage,
  toTitleCase,
  checkModulePermissions,
  getFirstAvailableRoute,
} from '../permissions';

// ============== Date & Formatting Helpers ==============

// Date only: "Mar 06, 2026" — for listing pages / tables
export const formatDate = (date) => {
  return date ? moment(date).format('MMM DD, YYYY') : '-';
};

// Date + Time: "Mar 06, 2026 03:30 PM" — for detail pages
export const formatDateTime = (date) => {
  return date ? moment(date).format('MMM DD, YYYY hh:mm A') : '-';
};

// Time only: "03:30 PM" — for chat messages
export const formatTime = (date) => {
  return date ? moment(date).format('hh:mm A') : '-';
};

export const truncateString = (text, maxLength) => {
  if (!maxLength) {
    const words = text.split('_');
    const capitalizedText = words
      .map(
        (word) =>
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
      .join(' ');
    return capitalizedText;
  }
  if (text && text.length <= maxLength) {
    return text;
  } else return `${text && text.substring(0, maxLength)}...`;
};

export const getExpiresAt = () => {
  return localStorage.getItem('expiresAt') || null;
};

export const getUserProfile = () => {
  return localStorage.getItem('profile') || '';
};

export const getDate = () => {
  const today = new Date();
  const dayNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const dayOfWeek = today.getDay();
  const month = today.getMonth();
  const dayOfMonth = today.getDate();
  const year = today.getFullYear();
  const formattedDate = `${dayNames[dayOfWeek]}, ${monthNames[month]} ${dayOfMonth}, ${year}`;
  return formattedDate;
};

export const urlPagination = (filters, filterKey, filterValue) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    queryParams.append(key, value);
  });
  queryParams.set('page', 1);
  queryParams.set(filterKey, filterValue);
  const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
  window.history.pushState({}, '', newUrl);
};
